import { Theme } from '@material-ui/core';

export const muiDialogOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiDialogActions: {
    root: {
      padding: theme.spacing(2),
      borderTop: `1px ${theme.palette.grey[400]} solid`,
    },
  },
  MuiDialogContent: {
    root: {
      padding: theme.spacing(1, 3, 2, 3),
    },
  },
  MuiDialogTitle: {
    root: {
      padding: theme.spacing(2.31, 0, 2.31, 3),
      ...theme.typography.h4,
    },
  },
  MuiDialog: {
    paper: {
      borderRadius: 0,
    },
    paperWidthXl: {
      maxWidth: '1398px',
      height: '100%',
    },
  },
});
